export default __webpack_public_path__ + "static/media/the_empress.37d74e88.png";